import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04ee7a06")

_pushScopeId("data-v-04ee7a06")
const _hoisted_1 = { class: "mb-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "d-flex align-items-center",
    gutter: 10
  }, {
    default: _withId(() => [
      _createVNode(_component_el_col, { sm: 12 }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "description-wrapper", {
            data: { fromIndex: _ctx.fromIndex, untilIndex: _ctx.untilIndex, totalAllItems: _ctx.totalAllItems }
          }, () => [
            _renderSlot(_ctx.$slots, "description", {
              data: { fromIndex: _ctx.fromIndex, untilIndex: _ctx.untilIndex, totalAllItems: _ctx.totalAllItems }
            }, () => [
              _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("pagination.listState", {
                fromIndex: _ctx.fromIndex,
                untilIndex: _ctx.untilIndex,
                totalAllItems: _ctx.totalAllItems
              })), 1)
            ])
          ])
        ]),
        _: 3
      }),
      (!_ctx.hidePagination && !_ctx.isNeedToBeHideWhenOnlyOnePage)
        ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            class: "text-end",
            sm: 12
          }, {
            default: _withId(() => [
              _createVNode(_component_el_pagination, {
                class: "d-inline-block",
                "current-page": _ctx.page,
                "page-size": _ctx.perPage,
                "pager-count": _ctx.pagerCount,
                background: "",
                layout: _ctx.layout || 'prev, pager, next',
                total: _ctx.totalAllItems,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "pager-count", "layout", "total", "onCurrentChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})